module.exports = __webpack_public_path__ + "ui-static/img/logo-header_dark.8d72ebe1.svg";